// src/services/pushNotificationService.js - CORRECTED VERSION
import { API } from '../utils/config';

class PushNotificationService {
  constructor() {
    this.vapidPublicKey = null;
    this.subscription = null;
    // Remove the isSupported property - only use the method
  }

  async getVapidPublicKey() {
  if (this.vapidPublicKey) {
    return this.vapidPublicKey;
  }

  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    const headers = {
      'Content-Type': 'application/json'
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API}/push/vapid-public-key`, {
      headers: headers
    });

    if (response.ok) {
      const data = await response.json();
      this.vapidPublicKey = data.public_key;
      return this.vapidPublicKey;
    } else {
      throw new Error('Failed to get VAPID public key');
    }
  } catch (error) {
    return null;
  }
}

debugTokenIssue() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  const sessionToken = sessionStorage.getItem('token');

  const allLocalKeys = Object.keys(localStorage);
  const tokenKeys = allLocalKeys.filter(key =>
    key.toLowerCase().includes('token') ||
    key.toLowerCase().includes('auth') ||
    key.toLowerCase().includes('jwt')
  );

  const allSessionKeys = Object.keys(sessionStorage);
  const sessionTokenKeys = allSessionKeys.filter(key =>
    key.toLowerCase().includes('token') ||
    key.toLowerCase().includes('auth') ||
    key.toLowerCase().includes('jwt')
  );

  this.testTokenWithKnownEndpoint();
}
  
/**
 * Test token with a known working endpoint
 */
async testTokenWithKnownEndpoint() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  try {
    const response = await fetch('${API}/vehicles', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
  }
}

// Update your getVapidPublicKey method with better token debugging
async getVapidPublicKey() {
  if (this.vapidPublicKey) {
    return this.vapidPublicKey;
  }

  try {
    this.debugTokenIssue();

    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    const headers = {
      'Content-Type': 'application/json'
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API}/push/vapid-public-key`, {
      headers: headers
    });

    if (response.ok) {
      const data = await response.json();
      this.vapidPublicKey = data.public_key;
      return this.vapidPublicKey;
    } else {
      const errorText = await response.text();
      throw new Error(`Failed to get VAPID public key: ${response.status}`);
    }
  } catch (error) {
    return null;
  }
}

/**
 * Test different request methods to isolate the auth issue
 */
async debugRequests() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  try {
    const getResponse = await fetch(`${API}/push/vapid-public-key`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (getResponse.ok) {
      const data = await getResponse.json();
    }
  } catch (error) {
  }

  try {
    const statusResponse = await fetch(`${API}/push/subscription/status`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (statusResponse.ok) {
      const data = await statusResponse.json();
    } else {
      const errorText = await statusResponse.text();
    }
  } catch (error) {
  }

  try {
    const testResponse = await fetch(`${API}/push/test`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        title: 'Debug Test',
        body: 'Testing auth for POST requests'
      })
    });
    if (testResponse.ok) {
      const data = await testResponse.json();
    } else {
      const errorText = await errorResponse.text();
    }
  } catch (error) {
  }
}

async debugAuth() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  try {
    const response = await fetch(`${API}/push/vapid-public-key`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      const errorText = await response.text();
      return { success: false, error: errorText, status: response.status };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
}

  /**
   * Check if push notifications are supported
   */
  isSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window;
  }

  /**
   * Get VAPID public key from backend
   */
  async getVapidPublicKey() {
    if (this.vapidPublicKey) {
      return this.vapidPublicKey;
    }

    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await fetch(`${API}/push/vapid-public-key`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        this.vapidPublicKey = data.public_key;
        return this.vapidPublicKey;
      } else {
        throw new Error('Failed to get VAPID public key');
      }
    } catch (error) {
      return null;
    }
  }

  /**
   * Request notification permission
   */
  async requestPermission() {
    if (!this.isSupported()) {
      return false;
    }

    try {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (error) {
      return false;
    }
  }

  // New debug version of sendSubscriptionToBackend
async sendSubscriptionToBackendDebug(subscription) {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    const payload = {
      endpoint: subscription.endpoint,
      keys: {
        p256dh: this.arrayBufferToBase64(subscription.getKey('p256dh')),
        auth: this.arrayBufferToBase64(subscription.getKey('auth'))
      }
    };

    const response = await fetch(`${API}/push/subscribe`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Backend error: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    return true;

  } catch (error) {
    return false;
  }
}

  /**
   * Subscribe to push notifications
   */
  async subscribe() {

  if (!this.isSupported()) {
    return false;
  }

  try {
    await this.debugRequests();

    const registration = await navigator.serviceWorker.ready;

    const vapidPublicKey = await this.getVapidPublicKey();
    if (!vapidPublicKey) {
      throw new Error('Could not get VAPID public key');
    }

    const applicationServerKey = this.urlBase64ToUint8Array(vapidPublicKey);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey
    });

    const success = await this.sendSubscriptionToBackendDebug(subscription);

    if (success) {
      this.subscription = subscription;
      return true;
    } else {
      throw new Error('Failed to save subscription to backend');
    }

  } catch (error) {
    return false;
  }
}



  /**
   * Unsubscribe from push notifications
   */
  async unsubscribe() {
    try {
      if (this.subscription) {
        await this.subscription.unsubscribe();
      }

      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await fetch(`${API}/push/unsubscribe`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        this.subscription = null;
        return true;
      } else {
        throw new Error('Failed to remove subscription from backend');
      }

    } catch (error) {
      return false;
    }
  }

  /**
   * Check subscription status
   */
  async getSubscriptionStatus() {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await fetch(`${API}/push/subscription/status`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        return data.subscribed;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  /**
   * Send test notification
   */
  async sendTestNotification() {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await fetch(`${API}/push/test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          title: '🧪 Test Background Notification',
          body: 'This test notification should appear even when the app is closed!'
        })
      });

      if (response.ok) {
        return true;
      } else {
        throw new Error('Failed to send test notification');
      }
    } catch (error) {
      return false;
    }
  }

  /**
   * Complete diagnostic check for push notifications
   */
  async runDiagnostic() {

    const results = {
      browserSupport: false,
      serviceWorkerReady: false,
      notificationPermission: 'default',
      currentSubscription: null,
      vapidKey: null,
      backendSubscribed: false,
      testNotificationSent: false
    };

    try {
      results.browserSupport = this.isSupported();

      if (!results.browserSupport) {
        return results;
      }

      try {
        const registration = await navigator.serviceWorker.ready;
        results.serviceWorkerReady = !!registration;
      } catch (error) {
      }

      results.notificationPermission = Notification.permission;

      try {
        const registration = await navigator.serviceWorker.ready;
        results.currentSubscription = await registration.pushManager.getSubscription();
      } catch (error) {
      }

      try {
        results.vapidKey = await this.getVapidPublicKey();
      } catch (error) {
      }

      try {
        results.backendSubscribed = await this.getSubscriptionStatus();
      } catch (error) {
      }

      if (results.notificationPermission === 'granted' && results.backendSubscribed) {
        try {
          results.testNotificationSent = await this.sendTestNotification();
        } catch (error) {
        }
      }

      return results;

    } catch (error) {
      return results;
    }
  }

  /**
   * Send subscription to backend
   */
  async sendSubscriptionToBackend(subscription) {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    const response = await fetch(`${API}/push/subscribe`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        endpoint: subscription.endpoint,
        keys: {
          p256dh: this.arrayBufferToBase64(subscription.getKey('p256dh')),
          auth: this.arrayBufferToBase64(subscription.getKey('auth'))
        }
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Backend error: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    return true;

  } catch (error) {
    return false;
  }
}

  /**
   * Convert URL-safe base64 to Uint8Array
   */
  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  /**
   * Convert ArrayBuffer to base64
   */
  arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}

// Export singleton instance
export const pushNotificationService = new PushNotificationService();